import { Component, EventEmitter, Input, Output } from "@angular/core";
import { BlockBaseComponent } from "../../scene-blocks/block-base/block-base.component";
import { copyTextClipboard, isHostDevOrLocal, TOAST_FASTER } from "../../../../common";
import { StoreSelectorsService } from "../../../../services";
import { actionCopySceneAnimation, actionRemoveInSceneItem, actionUpdateSceneItem } from "../../../../store/actions/user.actions";
import { IAnimationEngine } from "../../../../interfaces";
import { animationDefault } from "../../scene-blocks/block-constants";
import { DialogPopComponent } from "../../../../components/dialog-pop/dialog-pop.component";
import { ToastrService } from "ngx-toastr";
import { TranslocoService } from "@ngneat/transloco";
import { MatDialog } from "@angular/material/dialog";
import { ToggleOption } from "../../../../components/setting-toggle-group/setting-toggle-group.component";
import * as _ from "lodash";

@Component({
    selector: "app-block-animation-config",
    templateUrl: "./block-animation-config.component.html",
    styleUrls: ["./block-animation-config.component.scss"]
})

export class BlockAnimationConfigComponent extends BlockBaseComponent {
    
    isHostDevOrLocal = false;
    animationClipboard = null;
    animationMode: 'inherit' | 'override' = 'inherit';
    animationOptions: ToggleOption[] = [];

    @Input() 
    set setAnimationMode(showAnimationEngine: number) {
        this.animationMode = showAnimationEngine === 1 ? 'override' : 'inherit';
    }

    @Output() update: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        public override storeSelector: StoreSelectorsService,
        public override dialog: MatDialog,
        private toastr: ToastrService,
        private translocoService: TranslocoService,
    ) {
        super(storeSelector);

        // Initialize animation options with translations
        this.animationOptions = [
            { value: 'inherit', label: this.translocoService.translate('general.inherit') },
            { value: 'override', label: this.translocoService.translate('general.override') }
        ];
    }

    override onInit() {
        this.isHostDevOrLocal = isHostDevOrLocal();
        this.cod(
            this.storeSelector.listenSceneAnimationClipboard().subscribe((value: IAnimationEngine) => {
                this.animationClipboard = value;
            })
        );
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
    }

    createAnimationSlice() {
        this.storeSelector.dispatch(actionUpdateSceneItem({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItemId,
            values: [{
                key: 'Animation',
                value: animationDefault,
                storePath: `Data[0]`
            }]
        }));
        this.onAnimationChanged();
    }

    removeAnimationSlice(event) {
        this.storeSelector.dispatch(actionRemoveInSceneItem({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItemId,
            values: [{
                key: 'Animation',
                value: null,
                storePath: 'Data[0]'
            }]
        }));
        this.onAnimationChanged();
    }

    devExportConfig() {
        const value: IAnimationEngine = this.sceneItem.Data[0]?.Animation?.[0];
        if (value)
            console.log(JSON.stringify(value));
    }

    copyAnimation() {
        const value: IAnimationEngine = this.sceneItem.Data[0]?.Animation?.[0];
        if (value) {
            this.storeSelector.dispatch(actionCopySceneAnimation({
                animation: value
            }));
        }
        // copyTextClipboard(JSON.stringify(value));
        // this.toastr.info(this.translocoService.translate('toast.copiedToClipboard', {}, this.translocoService.getActiveLang()), '', TOAST_FASTER);
    }

    pasteAnimation() {
        const msg = this.translocoService.translate('message.confirmPasteAnimation', {}, this.translocoService.getActiveLang());
        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '150px',
            width: '400px',
            data: {name: `${msg}`, showCancel: true}
        });
        this.cod(
            dialogRef.afterClosed().subscribe(result => {
                if (!result) return;
                // replace animation from copied one
                this.storeSelector.dispatch(actionUpdateSceneItem({
                    sceneId: this.sceneId,
                    sceneItemId: this.sceneItemId,
                    values: [{
                        key: 'Animation',
                        value: [this.animationClipboard],
                        storePath: `Data[0]`
                    }]
                }));
                this.toastr.info(this.translocoService.translate('toast.pasteAnimationSuccess', {}, this.translocoService.getActiveLang()), '', TOAST_FASTER);
            })
        );
        this.onAnimationChanged();
    }

    onChangeAnimationMode(selectedValue: string) {
        this.animationMode = selectedValue as 'inherit' | 'override';

        if (this.animationMode === 'override') {
            this.createAnimationSlice();
        } else {
            this.removeAnimationSlice(null);
        }
    }

    onAnimationChanged() {
        setTimeout(() => {
            if (this.update.observed) {
                this.update.emit();
            }
        });
    }
}
